<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UVP5yg/tc-custom/9780811768924.jpg?1709147588623" alt="This image is the cover for the book Custer at Gettysburg"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Custer at Gettysburg
      </h1>
      <p class="bookDescription body article font2">
        <b>“A mosaic of thousands of tiny pieces that, seen whole, amounts to a fascinating picture of what probably was the most important moment of the Civil War.” —Thomas E. Ricks, <i>New York Times</i> bestselling author of <i>The Generals</i></b><br/><br/> George Armstrong Custer is famous for his fatal defeat at the Little Bighorn in 1876, but Custer’s baptism of fire came during the Civil War. His true rise to prominence began at Gettysburg in 1863.<br/><br/> On the eve of the Battle of Gettysburg, Custer received promotion to brigadier general and command—his first direct field command—of the Michigan Cavalry Brigade, the “Wolverines.” Custer did not disappoint his superiors, who promoted him in a search for more aggressive cavalry officers. At approximately noon on July 3, 1863,  the melee that was East Cavalry Field at Gettysburg began. An hour or two into the battle, after many of his cavalrymen had been reduced to hand-to-hand infantry-style fighting, Custer ordered a charge of one of his regiments and led it into action himself, screaming one of the battle’s most famous lines: “Come on, you Wolverines!” Around three o’clock, the Confederates led by Stuart mounted a final charge, which mowed down Union cavalry—until it ran into Custer’s Wolverines, who stood firm, breaking the Confederates’ last attack.<br/><br/> In a book combining two popular subjects, Tucker recounts the story of Custer at Gettysburg with verve, shows how the Custer legend was born on the fields of the war’s most famous battle, and offers eye-opening new perspectives on Gettysburg’s overlooked cavalry battle.<br/>  <br/> “A thoughtful and challenging new look at the great assault at Gettysburg . . . Tucker is fresh and bold in his analysis and use of sources.” —William C. Davis, author of <i>Crucible of Command</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Phillip Thomas Tucker
      </h2>
      
      <p class="authorDescription body article">Phillip Thomas Tucker is a writer and historian who has edited more than two dozen books and written over sixty scholarly articles. His previous books include Pickett’s Charge: A New Look at Gettysburg’s Final Attack, which historian William C. Davis praised as “thoughtful and challenging . . . fresh and bold,” and Death at the Little Bighorn: A New Look at Custer, His Tactics, and the Tragic Decision Made at the Last Stand. For many years a civilian historian with the Department of Defense, he lives in Upper Marlboro, Maryland, and is a regular participant in book events at Gettysburg.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      STACKPOLE BOOKS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7246ff97